module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/personalize-runtime-2018-05-22.paginators.json
// module id = 583
// module chunks = 0